<div class="wrapper">
    <app-layout-header></app-layout-header>

    <app-layout-sidebar></app-layout-sidebar>

    <div class="content-wrapper pt-3">
        <router-outlet></router-outlet>
    </div>

    <app-layout-footer></app-layout-footer>
</div>